import React, { useEffect, useState } from 'react';

import styled from 'styled-components';

import Modal from 'components/lib/Modal';
import Radio from 'components/lib/Radio';

import { BULK_EDIT_TOGGLE_LABELS } from './constants';

const StyledModal = styled(Modal)`
  .ant-modal-content {
    .ant-modal-close {
      margin-right: 10px;
    }

    .ant-modal-header {
      border: none !important;
      padding: 30px !important;
      padding-bottom: 15px !important;
      margin-bottom: 0;
    }

    .ant-modal-footer {
      display: flex;
      flex-flow: row-reverse;

      .ant-btn:last-of-type {
        margin-left: 10px;
      }

      .ant-btn:first-of-type {
        margin-left: 10px;
      }

      .ant-btn {
        height: 40px;
        padding: 10px 45px 10px 44px;
        border-radius: 4px;
      }
    }
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-flow: column;
  gap: 0;
`;

const HeaderTitle = styled.div`
  font-size: 20px;
  font-weight: 900;
`;

const HeaderSubtitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
  margin-top: -3px;
`;

const Content = styled.div`
  display: flex;
  flex-flow: column;
  min-height: 180px;
  padding-top: 16px;
`;

const SectionTitle = styled.div`
  font-weight: 900;
`;

const Description = styled.div`
  margin-top: 6px;
`;

const Options = styled.div`
  margin-top: 18px;
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: center;
`;

const StyledRadio = styled(Radio)`
  &.large {
    font-size: 14px;
  }
`;

type Props = {
  isOpen: boolean;
  loading: boolean;
  selectedCompanyNames: string[];
  onClose: () => void;
  onSave: (enabled: boolean) => void;
};

const IncentiveScrappingBulkEditModal = ({ isOpen, loading, selectedCompanyNames, onClose, onSave }: Props) => {
  const [enabled, setEnabled] = useState<boolean | null>(null);

  useEffect(() => {
    if (isOpen) {
      setEnabled(null);
    }
  }, [isOpen]);

  const subtitle =
    selectedCompanyNames.length === 1 ? selectedCompanyNames[0] : `${selectedCompanyNames.length} companies selected`;

  return (
    <StyledModal
      title={
        <HeaderContainer>
          <HeaderTitle>Incentive Scrapping</HeaderTitle>
          <HeaderSubtitle>{subtitle}</HeaderSubtitle>
        </HeaderContainer>
      }
      open={isOpen}
      onOk={() => {
        if (enabled !== null) {
          onSave(enabled);
        }
      }}
      onCancel={onClose}
      centered
      okText="Save"
      okButtonProps={{ disabled: loading || enabled === null, loading }}
      width={540}
    >
      <Content>
        <SectionTitle>Incentive Scrapping Status</SectionTitle>
        <Description>Choose if Incentive Scrapping should be enabled for selected companies.</Description>
        <Options>
          <StyledRadio className={'large'} checked={enabled === true} onChange={() => setEnabled(true)}>
            {BULK_EDIT_TOGGLE_LABELS.on}
          </StyledRadio>
          <StyledRadio className={'large'} checked={enabled === false} onChange={() => setEnabled(false)}>
            {BULK_EDIT_TOGGLE_LABELS.off}
          </StyledRadio>
        </Options>
      </Content>
    </StyledModal>
  );
};

export default IncentiveScrappingBulkEditModal;
